// One-line summaries for the rows on the Settings page (issue #86). Each row
// opens a sheet holding several related settings, so its summary has to say
// what's set without listing everything.

export const CHANGEOVER_OPTIONS = [
  {
    value: "wait",
    label: "Wait for me",
    description: "Holds until you tap Go. Best when the next station takes setting up.",
  },
  { value: "count", label: "Count me in", description: "A short count-in, then it starts on its own." },
  {
    value: "off",
    label: "Straight through",
    description: "No hold. The timed work starts as soon as the reps end.",
  },
];

export const describeCoachScreen = (ws) => {
  const phase = ws.drainTimer ?? false;
  const segments = ws.drainSegments ?? false;
  const rings = phase === segments ? (phase ? "Rings drain" : "Rings fill") : "Rings mixed";
  const extras = [
    (ws.autoFollowPhasePane ?? true) && "follows equipment",
    (ws.pauseOnMacroTap ?? true) && "pause to preview",
    ws.coachOrientation === "portrait" && "upright",
  ].filter(Boolean);
  return [rings, ...extras].join(" · ");
};

export const describeRests = (ws) =>
  `${ws.skipLastRest ?? true ? "Skip last rest" : "Keep last rest"} · ${ws.recoveryIdleThresholdMinutes ?? 10} min`;

export const describeSounds = (audio, profileLabel) =>
  audio.muted ? "Muted" : `${profileLabel} · ${Math.round((audio.volume ?? 0) * 100)}%`;

export const describeCountdowns = (audio) =>
  `${audio.countInDuration ?? 3} s count-in · ${audio.countdownEnabled ? "ticks" : "no ticks"}`;

export const describePhone = (audio, ws) => {
  const on = [
    audio.hapticEnabled && "Vibrate",
    ws.wakeLockEnabled && "screen stays on",
    ws.weatherOnSessions && "weather",
  ].filter(Boolean);
  if (on.length === 0) return "Off";
  const text = on.join(" · ");
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const describeBadges = (ws) => ((ws.showBadges ?? true) ? "On" : "Off");
export const describeOfferPairing = (ws) => ((ws.showConnectTrainer ?? true) ? "Offer pairing" : "Don't offer");

export const formatLastSeen = (timestamp, now = new Date()) => {
  if (!timestamp) return "Never";
  const date = new Date(timestamp);
  const diffMin = Math.floor((now - date) / 60000);
  if (diffMin < 1) return "Just now";
  if (diffMin < 60) return `${diffMin} min ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr} h ago`;
  return date.toLocaleDateString();
};
